import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './EmailValidationRulesTableHeadRow.scss';

export const EMAIL_VALIDATION_RULES_TABLE_HEADER = [
  { label: 'rule', sortBy: 'rule' },
  { label: 'action', sortBy: 'action' },
  { label: 'createdAt', sortBy: 'created_at' },
  { label: 'delete' }
];

export const EmailValidationRulesTableHeadRow = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {EMAIL_VALIDATION_RULES_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'email-validation-rules-table-head'}>
          <div className={'email-validation-rules-table-head-block'}>
            <span>{i18n.getMessage(`emailValidationRules.table.header.${head.label}`)}</span>
            {head.sortBy && (
              <ArrowSelect
                onClick={() => handleOnSortTable(head.sortBy)}
                className={`email-validation-rules-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
              />
            )}
          </div>
        </th>
      ))}
    </tr>
  );
};

EmailValidationRulesTableHeadRow.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};
